import { render, staticRenderFns } from "./questionList.vue?vue&type=template&id=dbffa286&"
import script from "./questionList.vue?vue&type=script&lang=js&"
export * from "./questionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbffa286')) {
      api.createRecord('dbffa286', component.options)
    } else {
      api.reload('dbffa286', component.options)
    }
    module.hot.accept("./questionList.vue?vue&type=template&id=dbffa286&", function () {
      api.rerender('dbffa286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/organisms/QuestionList/questionList.vue"
export default component.exports